import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveUIService {

  private device = new BehaviorSubject<string | undefined>(undefined);
  public devicestatus:any;
  public screenWidth: string | undefined = undefined;
  public screenSize:any;

  destroyed = new Subject<void>();
  currentScreenSize: string | undefined;

  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

  constructor(breakpointObserver: BreakpointObserver) {
    this.checkWidth();

    breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
          }
        }
        // if(this.currentScreenSize === 'XSmall' || this.currentScreenSize === 'Small'){
        //   this.onDeviceChange('sm');
        // }else if(this.currentScreenSize === 'Medium'){
        //   this.onDeviceChange('md');
        // }else if(this.currentScreenSize === 'Large' || this.currentScreenSize === 'XLarge'){
        //   this.onDeviceChange('lg');
        // }


        if(this.currentScreenSize === 'XSmall'){
          this.onDeviceChange('xsm');
        }else if(this.currentScreenSize === 'Small'){
          this.onDeviceChange('sm');
        }else if(this.currentScreenSize === 'Medium'){
          this.onDeviceChange('md');
        }else if(this.currentScreenSize === 'Large'){
          this.onDeviceChange('lg');
        }else if(this.currentScreenSize === 'XLarge'){
          this.onDeviceChange('xlg');
        }

      });
  }

  onDeviceChange(value: string) {
    this.device.next(value);
  }

  getDeviceStatus(): Observable<any> {
    return this.device.asObservable();
  }

  checkWidth() {
    this.devicestatus='';
    var width = window.innerWidth;
    this.screenSize=width;
    if (width <= 768) {
      this.screenWidth = 'sm';
      this.devicestatus ='sm';
    } else if (width > 768 && width <= 992) {
      this.screenWidth = 'md';
      this.devicestatus ='md';
    } else {
      this.screenWidth = 'lg';
      this.devicestatus ='lg';
    }
  }
}
